var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00af6d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5279 15.9018V18.5683H18.0962V21.4701H12.5279V24.1366H18.7236V27.0384H9.46924V13H18.7236V15.9018H12.5279Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3888 18.6467H23.5848C24.2384 17.6272 25.2187 17.1174 26.5258 17.1174C27.7284 17.1174 28.6238 17.503 29.212 18.2742C29.8002 19.0454 30.0943 20.0584 30.0943 21.3132V27.0384H27.1533V21.6466C27.1533 21.1237 27.0291 20.6989 26.7807 20.3721C26.5324 20.0323 26.1468 19.8623 25.6239 19.8623C24.9573 19.8623 24.4475 20.1172 24.0946 20.627C23.7548 21.1368 23.5848 21.8034 23.5848 22.6269V27.0384H20.6438V17.4311H23.3888V18.6467Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.1e105694.svg";
export { ForwardRef as ReactComponent };